/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  ApiKey,
  CreateApiKeyRequest,
  CreateApiKeyResponse,
  DeleteAdminV1StoresStoreIdApiKeysIdPathParameters,
  GetAdminV1StoresStoreIdApiKeys200,
  GetAdminV1StoresStoreIdApiKeysPathParameters,
  PatchAdminV1StoresStoreIdApiKeysIdPathParameters,
  PostAdminV1StoresStoreIdApiKeysIdRevokePathParameters,
  PostAdminV1StoresStoreIdApiKeysPathParameters,
  UpdateApiKeyRequest
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary List the API keys of a store
 */
export const getAdminV1StoresStoreIdApiKeys = (
    { storeId }: GetAdminV1StoresStoreIdApiKeysPathParameters,
 options?: SecondParameter<typeof customInstance<GetAdminV1StoresStoreIdApiKeys200>>,) => {
      return customInstance<GetAdminV1StoresStoreIdApiKeys200>(
      {url: `/admin/v1/stores/${storeId}/api-keys`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Create an API key. The key itself is returned once.
 */
export const postAdminV1StoresStoreIdApiKeys = (
    { storeId }: PostAdminV1StoresStoreIdApiKeysPathParameters,
    createApiKeyRequest: BodyType<CreateApiKeyRequest>,
 options?: SecondParameter<typeof customInstance<CreateApiKeyResponse>>,) => {
      return customInstance<CreateApiKeyResponse>(
      {url: `/admin/v1/stores/${storeId}/api-keys`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createApiKeyRequest
    },
      options);
    }
  /**
 * Same rules as create: a publishable key keeps at least one origin, a secret key takes none. CORS for added and removed origins follows at once. 409 on a revoked key
 * @summary Change a key's name, allowed origins, scopes or rate limit
 */
export const patchAdminV1StoresStoreIdApiKeysId = (
    { storeId, id }: PatchAdminV1StoresStoreIdApiKeysIdPathParameters,
    updateApiKeyRequest: BodyType<UpdateApiKeyRequest>,
 options?: SecondParameter<typeof customInstance<ApiKey>>,) => {
      return customInstance<ApiKey>(
      {url: `/admin/v1/stores/${storeId}/api-keys/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateApiKeyRequest
    },
      options);
    }
  /**
 * @summary Delete an API key (revoked or not); it stops working at once
 */
export const deleteAdminV1StoresStoreIdApiKeysId = (
    { storeId, id }: DeleteAdminV1StoresStoreIdApiKeysIdPathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/v1/stores/${storeId}/api-keys/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Revoke an API key
 */
export const postAdminV1StoresStoreIdApiKeysIdRevoke = (
    { storeId, id }: PostAdminV1StoresStoreIdApiKeysIdRevokePathParameters,
 options?: SecondParameter<typeof customInstance<ApiKey>>,) => {
      return customInstance<ApiKey>(
      {url: `/admin/v1/stores/${storeId}/api-keys/${id}/revoke`, method: 'POST'
    },
      options);
    }
  export type GetAdminV1StoresStoreIdApiKeysResult = NonNullable<Awaited<ReturnType<typeof getAdminV1StoresStoreIdApiKeys>>>
export type PostAdminV1StoresStoreIdApiKeysResult = NonNullable<Awaited<ReturnType<typeof postAdminV1StoresStoreIdApiKeys>>>
export type PatchAdminV1StoresStoreIdApiKeysIdResult = NonNullable<Awaited<ReturnType<typeof patchAdminV1StoresStoreIdApiKeysId>>>
export type DeleteAdminV1StoresStoreIdApiKeysIdResult = NonNullable<Awaited<ReturnType<typeof deleteAdminV1StoresStoreIdApiKeysId>>>
export type PostAdminV1StoresStoreIdApiKeysIdRevokeResult = NonNullable<Awaited<ReturnType<typeof postAdminV1StoresStoreIdApiKeysIdRevoke>>>
